import {Inject, Injectable} from '@angular/core';
import {AdminService} from "../../../admin/services/admin.service";
import { FirebaseService } from '../../../services/firebase.service';
import { UploadTask } from 'firebase/storage';


@Injectable()
export class CameraService {
  company: AdminService
  constructor(
    private firebase: FirebaseService,
    company: AdminService
  ) {
    this.company = company
  }
  saveImage (imageData: File): UploadTask {
    const filePath = `images/${new Date().toISOString()}-${Math.random() * 100000}.${imageData.name.replace(/^.*\./, '')}`;
    return this.firebase.uploadFileResumable(imageData,filePath, {
      cacheControl: 'public,max-age=15552000',
    });
  }
  saveBlob (imageData: Blob,format='png'): UploadTask {
    const filePath = this.generateFilePath(format);
    return this.firebase.uploadFileResumable(imageData,filePath, {
      cacheControl: 'public,max-age=15552000',
    });
  }

  generateFilePath (format: string): string {
    return `images/${new Date().toISOString()}-${Math.random() * 100000}.${format}`;
  }

  trimImage (c: any) {
    const ctx = c.getContext('2d'),
      copy = document.createElement('canvas').getContext('2d'),
      pixels = ctx.getImageData(0, 0, c.width, c.height),
      l = pixels.data.length,
      bound: { top: number | null, left: number | null, right: number | null, bottom: number | null } = {
        top: null,
        left: null,
        right: null,
        bottom: null
      };
      let i, x, y;

    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~((i / 4) / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }

    const trimHeight = (bound.bottom ?? c.height) - (bound.top ?? 0),
      trimWidth = (bound.right ?? c.width) - (bound.left ?? 0),
      trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

    if (copy) {
      copy.canvas.width = trimWidth;
      copy.canvas.height = trimHeight;
      copy.putImageData(trimmed, 0, 0);
      return copy.canvas;
    }

    return null;
  }
}
